<template>
  <div class="chat">
    <img v-if="this.messages.length == 0" width="200" class="messages-empty-image" src="http://www.iconninja.com/files/719/390/444/empty-notification-email-mail-icon.svg" alt="Messages Empty">

    <div ref="header" class="header">
      <div class="pull-right text-right">
        <h4 class="status">
          <span class="label" :class="this.status == 'Connected!' ? 'label-success' : (this.status == 'Disconnected!' ? 'label-danger' : 'label-default')">
            {{ this.status }}
          </span>
        </h4>
        <span>Users online: {{ this.$parent.onlineUsers || '...' }}</span>
      </div>
      <h1>Chat</h1>
    </div>

    <div ref="messages" class="messages">
      <div class="message" v-for="(message, index) in messages" :key="index">
        <strong :class="message.stranger ? 'stranger' : 'me'">{{ message.stranger ? 'Stranger' : 'You' }}</strong>:
        {{ message.body }}
      </div>

      <strong class="typing" v-if="typing.stranger">
        Typing...
      </strong>
    </div>

    <div ref="footer" class="footer">
      <div class="input-group">
        <input type="text" @input="isTyping" :disabled="this.status != 'Connected!'" @keydown.enter="createMessage" class="form-control" placeholder="Hit Enter to send...">
        <span class="input-group-btn">
          <button @click="newChat" v-if="this.status == 'Disconnected!'" class="btn btn-primary">New Chat</button>
          <button tabindex="-1" @click="disconnect" v-else :disabled="this.status == 'Connecting...' || this.status == 'Disconnecting...'" class="btn btn-default">Disconnect</button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'chat',
  data () {
    return {
      status: 'Connecting...',
      hash: window.localStorage.getItem('hash') || null,
      messages: this.getLocalStorageObject('messages') || [],
      typing: {
        me: false,
        stranger: false,
        meTimeout: null,
        strangerTimeout: null,
        timeLimit: 5000,
      },
    }
  },
  watch: {
    authId (newVal, oldVal) {
      if (newVal !== null) {
        this.start();
      }
    },

    messages () {
      setTimeout(() => {
        document.querySelector('html').scrollTop = 99999999
      }, 10)
    },
  },
  computed: {
    authId () {
      return this.$parent.authId
    }
  },
  mounted () {
    this.$refs.messages.style.marginTop = `${this.$refs.header.clientHeight}px`
    this.$refs.messages.style.marginBottom = `${this.$refs.footer.clientHeight}px`

    setTimeout(() => {
      document.querySelector('html').scrollTop = 99999999
    }, 100)
  },
  created () {
    window.axios.interceptors.response.use(response => response, (error) => {
      if (error.request.status == 403 || error.request.status == 404) {
        this.hash = null
        this.status = 'Disconnected!'

        window.localStorage.removeItem('hash')
        window.localStorage.removeItem('messages')
      }

      return Promise.reject(error)
    })

    if (this.authId !== null) {
      this.start();
    }
  },
  beforeRouteLeave (to, from, next) {
    Echo.leave(`App.Chat.${this.hash}`)
    next()
  },
  methods: {
    start () {
      if (this.hash) {
        this.connect()

      } else {
        axios.get('/chat').then(response => {
          this.hash = response.data.hash

          window.localStorage.setItem('hash', response.data.hash)

          this.connect()
        })
      }
    },

    connect () {
      Echo.join(`App.Chat.${this.hash}`)
        .here((users) => {
          if (users.length > 1) {
            this.status = 'Connected!'

          } else {
            this.status = 'Waiting for the stranger...'
          }
        })

        .joining((user) => {
          this.status = 'Connected!'
        })

        .leaving((user) => {
          if (this.hash) {
            this.status = 'Stranger is offline. Trying to reconnect...'
          }
        })

        .listen('ChatDisconnected', (e) => {
          this.typing.me = false
          this.typing.stranger = false
          clearTimeout(this.typing.strangerTimeout)

          Echo.leave(`App.Chat.${this.hash}`)

          this.hash = null
          this.status = 'Disconnected!'

          window.localStorage.removeItem('hash')
          window.localStorage.removeItem('messages')
        })

        .listenForWhisper('message', (e) => {
          this.typing.me = false
          this.typing.stranger = false
          clearTimeout(this.typing.strangerTimeout)

          this.messages.push({
            stranger: e.authId != this.authId,
            body: e.message
          })

          this.setLocalStorageObject('messages', this.messages)
        })

        .listenForWhisper('typing', (e) => {
          if (e.authId != this.authId) {
            this.typing.stranger = true

            clearTimeout(this.typing.strangerTimeout)

            this.typing.strangerTimeout = setTimeout(() => {
              this.typing.stranger = false
            }, this.typing.timeLimit)

            setTimeout(() => {
              document.querySelector('html').scrollTop = 99999999
            }, 10)
          }
        })
    },

    isTyping () {
      if (!this.typing.me) {
        let authId = this.authId

        Echo.join(`App.Chat.${this.hash}`).whisper('typing', { authId })

        this.typing.me = true

        this.typing.meTimeout = setTimeout(() => {
          this.typing.me = false
        }, (this.typing.timeLimit / 1.3))
      }
    },

    disconnect () {
      axios.delete(`/chat/${this.hash}`).then(response => {
        Echo.leave(`App.Chat.${this.hash}`)
        this.status = 'Disconnected!'
      })

      this.hash = null
      this.status = 'Disconnecting...'

      window.localStorage.removeItem('hash')
      window.localStorage.removeItem('messages')
    },

    createMessage(e) {
      let message = e.target.value
      let authId = this.authId

      if (message.length === 0) return

      this.messages.push({
        stranger: false,
        body: message
      })

      Echo.join(`App.Chat.${this.hash}`).whisper('message', { message, authId })

      this.setLocalStorageObject('messages', this.messages)

      this.typing.me = false
      clearTimeout(this.typing.meTimeout)

      e.target.value = null
    },

    newChat () {
      this.messages = []
      this.status = 'Connecting...'
      this.start()
    },

    getLocalStorageObject (key) {
      return JSON.parse(window.localStorage.getItem(key))
    },

    setLocalStorageObject (key, value) {
      window.localStorage.setItem(key, JSON.stringify(value))
    },
  }
}
</script>

<style>
  .message {
    margin-bottom: 3px;
  }

  .message .stranger {
    color: red;
  }

  .header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #f2f6f9;
    border-bottom: 1px solid #ccc;
  }

  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: #f2f6f9;
    border-top: 1px solid #ccc;
  }

  .messages,
  .header,
  .footer {
    padding: 20px;
  }

  .footer input,
  .footer button {
    height: 60px;
  }

  .typing {
    color: #777
  }

  .messages-empty-image {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  @media (max-width: 768px) {
    .messages,
    .header,
    .footer {
      padding: 10px;
    }

    .footer input,
    .footer button {
      height: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Chat.vue